import React from 'react';
import { SETTING } from 'interfaces/settings';
import { TimeRangeControl } from './TimeRangeControl';
import { PhonePreferenceControl } from './PhonePreferenceControl';

export function CustomSettingControl({ settings }: { settings: SETTING[] }) {
    switch (settings[0]) {
        case SETTING.LOCAL_CALL_TIME_MIN:
        case SETTING.LOCAL_CALL_TIME_MAX:
            return <TimeRangeControl/>
        case SETTING.PHONE_PREFERENCE:
            return <PhonePreferenceControl/>;
        default:
            return null;
    }
    return null;
} 